import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
  Form,
  Message,
  Segment,
} from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import hasUserInfo from '../../hocs/has-user-info';

const messageStyles = {
  width: '100%',
};


class MailoutSendModal extends Component {
  constructor(props) {
    super(props);
    const mailout = _.get(props, 'mailout', {});
    this.state = { ...mailout };
  }

  onInputChanged = async (event, rest) => {
    const { name, value, checked } = rest;
    this.setState({
      [name]: value || checked,
    });
  }

  handleFormSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const {
      outreachEmailSubject,
      outreachEmailTemplate,
    } = this.state;
    this.setState({ error: null });
    if (outreachEmailSubject && outreachEmailTemplate) {
      onSubmit();
    }
  }

  render() {
    const {
      onClose,
      isSubmitting,
      error,
      successMessage,
    } = this.props;

    const {
      mailoutName,
      outreachEmailSubject,
      outreachEmailTemplate,
      utmSource,
      totalInfluencers,
      lastSentDate,
    } = this.state;

    const lastSentDateLabel = lastSentDate ? moment(lastSentDate).format('DD-MM-YYYY, h:mm') : 'Not sent yet';
    return (
      <div>
        <DyzioModal headerText="Send Mailout" size="small" onClose={onClose}>
          <div >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',

              }}
            >
              <h3>{mailoutName} </h3>
            </div>
            {error && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Message
                  fluid
                  style={messageStyles}
                  icon="frown"
                  error
                  header="Error"
                  content={error}
                />
              </div>
            )}
            {successMessage && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Message
                  success
                  fluid
                  style={messageStyles}
                  icon="check circle outline"
                  header="Mailout sent successfully!"
                  content={successMessage}
                />
              </div>
            )}


            <Form onSubmit={this.handleFormSubmit}>
              <div style={{ maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' }}>
                <Segment>
                  <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <h4>Email Subject</h4>
                    <h5 style={{ color: 'rgba(0,0,0,.4)' }}>{outreachEmailSubject || '-'}</h5>
                  </div>
                  <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <h4>Email Template</h4>
                    <h5 style={{ color: 'rgba(0,0,0,.4)' }}>{outreachEmailTemplate || '-'}</h5>
                  </div>
                  <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <h4>UTM Source</h4>
                    <h5 style={{ color: 'rgba(0,0,0,.4)' }}>{utmSource || '-'}</h5>
                  </div>
                  <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <h4>Total Influencers: {totalInfluencers}</h4>
                  </div>
                  <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <h4>Last sent date</h4>
                    <h5 style={{ color: 'rgba(0,0,0,.4)' }}>{lastSentDateLabel}</h5>
                  </div>
                </Segment>
              </div>
              <div
                className="flex"
                style={{
                  justifyContent: 'flex-end',
                  padding: '10px 0px 10px 0px',
                }}
              >
                <Form.Button
                  loading={isSubmitting}
                  disabled={isSubmitting || error || successMessage}
                  color="pink"
                  type="submit"
                  size="medium"
                >
                Submit
                </Form.Button>
              </div>
            </Form>

          </div>
        </DyzioModal>
      </div>
    );
  }
}

MailoutSendModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.any,
  successMessage: PropTypes.any,
};
MailoutSendModal.defaultProps = {
  onClose: _.noop,
  onSubmit: _.noop,
  isSubmitting: false,
  error: null,
  successMessage: null,
};
export default compose(
  hasUserInfo,
)(MailoutSendModal);



/** WEBPACK FOOTER **
 ** ./src/components/mailout-send-modal/index.js
 **/